import { t } from 'i18next';

export const dashboardTabs = {
  orders: {
    key: 'orders',
    label: t('orders.orders'),
  },
  jobInsights: {
    key: 'jobInsights',
    label: t('jobs.jobInsights'),
  },
  inventoryInsights: {
    key: 'inventoryInsights',
    label: t('dashboard.inventoryInsights'),
  },
  fittingStatus: {
    key: 'fitting-status',
    label: t('dashboard.fittingStatus'),
  },
};
